// Gemeinsamer React-Baustein fuer die Sekundaer-Panels (Strangler Phase 5).
// Runbook: tools/REACT-STRANGLER.md.
//
// Alle Sekundaer-Panels (Kassenladen, Sonderfunktionen, Benutzerfunktionen,
// Bankomat, Straussfunktionen ...) sahen im Legacy gleich aus: dieselbe
// LYT_secondaryPanel.xml (CFrame "menuContainer" -> CPushPanel
// "functionButtons"), dieselbe makeFunctionButtons-Schleife, nur andere
// Beschriftungen und Handler. Genau diese Wiederholung faellt hier weg -
// das BILD bleibt dabei zeichengleich:
//   - dieselben Klassen (CFrame / CPushPanel / CPushButton / CCaption),
//   - dieselben gerechneten Inline-Styles (Rasterrechnung unten),
//   - dieselbe Eigenheit des Legacy-Builders, den Beschriftungs-WERT roh in
//     die class des CCaption zu schreiben (deshalb steht in den Baselines
//     z.B. class="CCaption Umschalten&lt;br/&gt;mobil").
//
// Das VERHALTEN bleibt ebenfalls: die Knoepfe haengen ueber bridge.widget am
// Legacy-Dispatcher (Lock, Beep, on*_parameter_N), die Handler selbst sind
// woertlich die alten und holen sich ihr `me` wie gewohnt ueber
// POS.getComponentById(parameters[0]) - das liefert die Bridge.
import { CPushButton } from '../components/pushbutton.js';

// Rasterrechnung aus CPushPanel.prototype.prepare - unveraendert uebernommen.
// `eigen` sind Breite/Hoehe, die der Knopf selbst mitbringt: CPushPanel setzt
// die gerechneten Werte NUR, wenn der Knopf keine hat ("if (!...width)"), und
// der defaultButton der Layout-XML gewinnt anschliessend ohnehin. Die
// Schluesselreihenfolge bleibt dabei gleich - darauf beruht, dass das
// style-Attribut zeichengleich herauskommt.
export function rasterStyle(spalten, zeilen, index, eigen = {}) {
  const colSpace = 100 / spalten;
  const rowSpace = 100 / zeilen;
  const r = Math.floor(index / spalten);
  const c = index % spalten;
  return {
    width: eigen.width || colSpace * 0.90 + '%',
    height: eigen.height || rowSpace * 0.85 + '%',
    position: 'absolute',
    top: rowSpace * r + '%',
    left: colSpace * c + '%',
  };
}

// Ein Knopf: { text, handler, param0?, param1? }.
// param0 ist normalerweise die eigene Bridge-ID (so wie das Legacy-
// makeFunctionButtons sie setzt). CInventoryPanel zeigt, warum es trotzdem
// ueberschreibbar sein muss: zwei seiner Knoepfe rufen Methoden eines ANDEREN
// Screens (Main.cmpChanges) und geben deshalb dessen ID mit.
// `text` darf - wie im Legacy - HTML enthalten ("Umschalten<br/>mobil").
// `knopfStyle` sind Zusatz-Styles fuer ALLE Knoepfe des Panels. Das ist kein
// Zierrat: laut Baselines hat einzig CCashboxPanel ein
// background-repeat: no-repeat auf seinen Knoepfen - haette der Baustein das
// fest verdrahtet, waeren die vier anderen Panels nicht mehr zeichengleich.
export function PanelButton({ bridge, pfad, spalten, zeilen, index, knopf, knopfStyle }) {
  const attributes = { onMousedown_parameter_0: knopf.param0 !== undefined ? knopf.param0 : bridge.id };
  if (knopf.param1 !== undefined) attributes.onMousedown_parameter_1 = knopf.param1;

  return (
    <div {...bridge.widget(pfad, 'CPushButton', {
           events: { onMousedown: knopf.handler, onMouseout: true, onMouseup: true },
           attributes,
           proto: CPushButton.prototype,
         })}
         className="CPushButton"
         style={{
           backgroundColor: '#EEEEEE',
           ...knopfStyle,
           ...rasterStyle(spalten, zeilen, index),
         }}>
      <p {...bridge.el(`${pfad}:0`, 'CCaption')} className={'CCaption ' + knopf.text}
         dangerouslySetInnerHTML={{ __html: knopf.text }} />
    </div>
  );
}

// Das ganze Panel. `knoepfe` muss das Raster VOLL besetzen - der Legacy-Fall
// "mehr Zellen als Knoepfe" (CPushPanel.prepare macht daraus unsichtbare
// Fuellknoepfe) kommt bei keinem der portierten Panels vor und wird hier
// bewusst nicht nachgebaut, statt ihn zu erraten.
export function SecondaryPanel({ bridge, spalten, zeilen = 1, knoepfe, knopfStyle }) {
  // Erst die Handles anlegen, dann unter ihren XML-Namen anmelden: die
  // Rechteverwaltung schaltet Knoepfe ueber
  // cmpX.components.menuContainer.components.functionButtons.children[N]
  // ab (pos/userrights.js, pos/sessionhandler.js). Ohne diese zwei Zeilen
  // faellt sie mit einem Alert schon beim Login um.
  const frameProps = bridge.el('0', 'CFrame');
  const panelProps = bridge.el('0:0', 'CPushPanel');
  bridge.nameComponent('0', 'menuContainer');
  bridge.nameComponent('0:0', 'functionButtons');

  return (
    <div {...frameProps} className="CFrame" style={{ position: 'absolute' }}>
      <div {...panelProps} className="CPushPanel">
        {knoepfe.map((k, i) => (
          <PanelButton key={i} bridge={bridge} pfad={`0:0:${i}`} knopfStyle={knopfStyle}
                       spalten={spalten} zeilen={zeilen} index={i} knopf={k} />
        ))}
      </div>
    </div>
  );
}
